const CostsCard = ({
  materialCost,
  laborCost,
  totalCost,
  handleMaterialChange,
  handleLaborChange,
  handleTotalChange,
  formatMoney,
  setMaterialCost,
  setLaborCost,
  setTotalCost,
  handleSaveCosts,
  savingCosts,
  isWorkOrderUpdateDisabled,
}) => {
  return (
    <div className="uk-width-1-1 uk-margin-top">
      <div className="uk-card uk-card-default uk-card-small wo-costs-card" style={isWorkOrderUpdateDisabled ? { opacity: 0.6 } : {}}>
        <div className="uk-card-header uk-flex uk-flex-between uk-flex-middle">
          <h4 className="uk-margin-remove">Costs</h4>
        </div>

        <div className="uk-card-body">
          <div className="uk-grid-small" data-uk-grid style={{ gap: '8px' }}>
            <div style={{ flex: '0 0 calc(33.33% - 6px)' }}>
              <label className="uk-form-label">Material Cost</label>
              <div className="uk-inline uk-width-1-1">
                <span className="uk-form-icon">$</span>
                <input
                  className="uk-input"
                  type="text"
                  placeholder="0.00"
                  value={materialCost}
                  onChange={handleMaterialChange}
                  onBlur={() => setMaterialCost(formatMoney(materialCost))}
                  disabled={isWorkOrderUpdateDisabled}
                />
              </div>
            </div>

            <div style={{ flex: '0 0 calc(33.33% - 6px)' }}>
              <label className="uk-form-label">Labor Cost</label>
              <div className="uk-inline uk-width-1-1">
                <span className="uk-form-icon">$</span>
                <input
                  className="uk-input"
                  type="text"
                  placeholder="0.00"
                  value={laborCost}
                  onChange={handleLaborChange}
                  onBlur={() => setLaborCost(formatMoney(laborCost))}
                  disabled={isWorkOrderUpdateDisabled}
                />
              </div>
            </div>

            <div style={{ flex: '0 0 calc(33.33% - 6px)' }}>
              <label className="uk-form-label">Total Cost</label>
              <div className="uk-inline uk-width-1-1">
                <span className="uk-form-icon">$</span>
                <input
                  className="uk-input"
                  type="text"
                  placeholder="0.00"
                  value={totalCost}
                  onChange={handleTotalChange}
                  onBlur={() => setTotalCost(formatMoney(totalCost))}
                  disabled={isWorkOrderUpdateDisabled}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="uk-card-footer uk-text-right uk-padding-small no-print">
          <button
            type="button"
            className="uk-button hms-btn hms-red-btn"
            onClick={handleSaveCosts}
            disabled={savingCosts || isWorkOrderUpdateDisabled}
          >
            {savingCosts ? "Saving..." : "Save Costs"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CostsCard;
